import { Pipe, PipeTransform } from "@angular/core";

import { MedLocalizationService } from "../services/med-localization.service";

@Pipe({
  name: "translate",
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly localization: MedLocalizationService) {}

  transform(value: string): string {
    return this.localization.translate(value);
  }
}
